<template>
  <label
    class="flex h-[56px] grow-0 items-center gap-2 border-0 border-b-4 txt-label-s-bold uppercase has-[:focus-visible]:text-effect-focused has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2"
    :class="{
      [props.pxClass]: true,
      'border-selected': isChecked && !props.disabled,
      'border-disabled': isChecked && props.disabled,
      'border-transparent hover:border-subtle': !isChecked && !disabled,
      'text-disabled': props.disabled,
      'state-layer-neutral cursor-pointer text-main': !props.disabled,
    }"
  >
    <input
      v-if="props.selectedValue !== undefined"
      data-testid="tab-bar-item-input"
      :name="groupName"
      :disabled="props.disabled"
      class="sr-only"
      type="radio"
      :checked="isChecked"
      :value="props.selectedValue"
      @change="handleRadioChange"
    />

    <slot></slot>
  </label>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue'

import { TAB_BAR_GROUP_NAME } from './tabBarGroupName'

export interface Props {
  isChecked?: boolean
  modelValue?: string
  selectedValue?: string
  disabled?: boolean
  pxClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  isChecked: false,
  modelValue: '',
  selectedValue: undefined,
  disabled: false,
  pxClass: 'px-8',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const groupName = inject(TAB_BAR_GROUP_NAME, undefined)

const isChecked = computed(() => props.isChecked || props.modelValue === props.selectedValue)

function handleRadioChange(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}
</script>
